<template>
  <div>
    <DialogContainer v-model="dialogObj">
      <template v-slot:dialogSlot>
        <div class="business-body custom-form">
          <div class="search-form-box">
            <el-row :gutter="30">
              <el-form inline>
                <el-col :span="24">
                  <el-form-item label="">
                    <el-button type="primary" @click="handleAdd()">添加发货人</el-button>
                  </el-form-item>
                </el-col>
              </el-form>
            </el-row>
          </div>
          <custom-table
            :data="tableData"
            :column="tableColumn"
            :total="tableOptions.total"
            :loading="tableOptions.loading"
            :page="tableOptions.pageNumber"
            :size="tableOptions.pageSize"
            :selection="false"
            @pagination="handleSizeChange">
            <template v-slot:operation="{ row }">
              <span class="operate-btn" @click.stop="handleEdit(row)">编辑</span>
              <span class="operate-btn" @click.stop="handleResetPass(row)">重置密码</span>
              <span class="operate-btn" @click.stop="handleDelete(row.userId, '确定要删除此发货人吗')">删除</span>
            </template>
          </custom-table>
        </div>
      </template>
    </DialogContainer>
    <addOrEditShipper ref="addOrEditShipperRef"></addOrEditShipper>
  </div>
</template>

<script>
import addOrEditShipper from "./addOrEditShipper.vue";
import DialogContainer from "@/components/Dialog.vue";
import {deleteConsignerInfo, getConsignerPage, resetPassword} from "./api";
import CustomTable from "@/components/CustomTable.vue";
import tableMixin from "@/mixin/tableMixin";
export default {
  name: "ShipperManagement",
  mixins: [tableMixin],
  components: {
    CustomTable,
    DialogContainer,
    addOrEditShipper,
  },
  data() {
    return {
      isImmediatelyGetData: false,
      getTableMethod: getConsignerPage,
      deleteMethod: deleteConsignerInfo,
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "40%",
        show: false,
        title: "发货人管理",
        closeOnClickModal: false,
        confirmFn: "",
        beforeClose: (v) => {
          this.dialogObj.show = false;
        },
      },
      searchForm: {
        companyId: ""
      },
      cheImage: require("@/assets/imgs/title.png"),
      tableColumn: [
        {
          label: "发货人姓名",
          prop: "username",
          show: true,
        },
        {
          label: "手机号码",
          prop: "phone",
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "180px",
          scopeStatus: true,
          show: true,
        },
      ],
    };
  },
  mounted() {},
  methods: {
    handleAddOrEditSuccess() {
      this.$parent.getTableData()
      this.getTableData()
    },
    handleOtherOperate() {
      this.$parent.getTableData()
    },
    handleEdit(row){
      this.$refs.addOrEditShipperRef.init(this.searchForm.companyId, row);
    },
    handleAdd(){
      this.$refs.addOrEditShipperRef.init(this.searchForm.companyId);
    },
    init(row) {
      this.searchForm.companyId = row.companyId
      this.getTableData()
      this.dialogObj.show = true;
    },
    handleResetPass(row) {
      this.$confirm(`确定重置此发货人密码？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        resetPassword({ userId: row.userId }).then((res) => {
          if (res.code === 200) {
            this.$message.success("密码重置成功");
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .left-box {
    padding-right: 0.5rem;
    padding-bottom: 0.1rem;
    position: relative;
    display: flex;
    align-items: center;
    .left-box-top {
      display: flex;
      align-items: center;
      .label {
        width: 0.2rem;
        height: 0.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.02rem;
        font-size: 0.12rem;
      }
      .zhuang {
        color: #5cc41a;
        background-color: rgba(92, 196, 26, 0.3);
      }
      .xie {
        color: #e52019;
        background-color: rgba(229, 32, 25, 0.3);
      }
      .name {
        color: #000000;
        font-size: 0.18rem;
        line-height: 0.2rem;
        padding-left: 0.04rem;
      }
    }
    .date {
      color: #8c8c8c;
      font-size: 0.12rem;
      line-height: 0.2rem;
    }
  }
  .left-box:nth-last-of-type(1)::before {
    display: none;
  }
  .car-img {
    width: 0.1rem;
    height: 0.1rem;
    margin-right: 0.04rem;
  }
  .center-box-2 {
    display: flex;
    align-items: center;
    line-height: 0.24rem;
    color: #000000;
    font-size: 0.12rem;
    position: relative;
  }
  .center-box-2 {
    padding-left: 0.2rem;
    position: relative;
    &::before {
      content: "";
      width: 0.01rem;
      height: 0.1rem;
      background-color: #dce5f5;
      position: absolute;
      left: 0.1rem;
    }
  }
  .center-box-1 {
    color: #1269ff;
  }
  .title-box {
    padding: 0rem 0 0.1rem;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
  }
  .tip {
    font-size: 0.12rem;
    padding-left: 0.1rem;
    color: #999999;
  }
}
</style>
